import * as React from "react"

import Header from "./header"
import Footer from "./footer"

type Props = {
  children: React.ReactNode
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}

class Layout extends React.Component<Props> {
  render() {
    const { children, utmSource, utmMedium, utmCampaign, utmContent } = this.props

    return (
      <>
        <Header
          utmSource={utmSource}
          utmMedium={utmMedium}
          utmCampaign={utmCampaign}
          utmContent={utmContent}
        />
        <main>{children}</main>
        <Footer
          utmSource={utmSource}
          utmMedium={utmMedium}
          utmCampaign={utmCampaign}
          utmContent={utmContent}
        />
      </>
    )
  }
}

export default Layout
